



















































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import documentoService from "./documento-service";
import { obterDataFormatada, isMobile } from "../../utils/utils";
import env from '../../env/env';
import empresaAtualService from '../empresa-atual/empresa-atual-service';
import areaService from '../area-atual/area-service';

@Component
export default class DocumentoVisualizar extends Vue {

    modalAberto = false;

    TipoArquivo = Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo;

    linkDownloadArquivo: string = null;

    escalaAtualImagem = 1;

    isMobile = isMobile();

    empresaId: any = null

    areaAtual: string = null;

    async obterEmpresaId() {
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
    }

    modal: {
        id: string,
        titulo: string,
        conteudo: string,
        exibeArquivo: boolean
    } = null;

    async imprimirDocumento(event, documentoId: string) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!documentoId && this.modal)
            documentoId = this.modal.id;

        let resultado = await documentoService.obterArquivo({
            id: documentoId,
            empresaId: this.empresaId,
        });

        let pagina = window.open("");

        if (resultado.tipoArquivo == Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo.Pdf) {
            pagina.document.write(`<object width='100%' type='application/pdf' id='t-frame' height='100%'
          data='data:application/pdf;base64, ${encodeURI(resultado.arquivo)}'></object>`);
        }
        else {
            if (resultado.extensao.toLowerCase() == '.svg')
                pagina.document.write(`<img src='data:image/svg+xml;base64, ${resultado.arquivo}'></img>`);
            else {
                let extensao = resultado.extensao.toLowerCase().substr(1);

                pagina.document.write(`<img src='data:image/${extensao};base64, ${resultado.arquivo}'></img>`);
            }
        }

        setTimeout(() => pagina.print(), 1000);
    }

    fecharModal() {
        this.modalAberto = false;

        this.modal = null;

        this.escalaAtualImagem = 1;
    }

    async exibirDocumento(event, documentoId: string, documentoTitulo: string) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.modalAberto = true;

        let resultado = await documentoService.obterArquivo({
            id: documentoId,
            empresaId: this.empresaId,
        });

        this.modal = {
            id: documentoId,
            titulo: documentoTitulo,
            conteudo: this.obterConteudo(resultado),
            exibeArquivo: resultado.tipoArquivo != Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo.Outro
        }

        this.linkDownloadArquivo = `${env.apiUrl}/api/Documentos/BaixarArquivo?id=${documentoId}&empresaId=${this.empresaId}`;
    }

    obterConteudo(resultado: { arquivo: string, tipoArquivo: Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo, extensao: string }) {
        if (resultado.tipoArquivo == Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo.Imagem) {

            let extensao = resultado.extensao.toLowerCase().substr(1);

            return `data:image/${extensao};base64, ${resultado.arquivo}`;
        }

        if (resultado.tipoArquivo == Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo.Svg)
            return `data:image/svg+xml;base64, ${resultado.arquivo}`;

        if (resultado.tipoArquivo == Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo.Pdf)
            return `data:application/pdf;base64,  ${resultado.arquivo}`;

        return null;
    }

    incrementarZoom(event, incremento: number) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.escalaAtualImagem = this.escalaAtualImagem + incremento;

        if (this.escalaAtualImagem <= 0)
            this.escalaAtualImagem = 0.1;

        let imagem = this.$refs.imagemModal as HTMLImageElement;

        imagem.style.transform = `scale(${this.escalaAtualImagem})`;
    }

    async carregarDados() {
        await this.obterEmpresaId();
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        this.carregarDados();
    }
}
